import { useContext } from 'react';
import useSubmitNew from 'shared/hooks/useSubmitNew';
import MassActionModalLayout from 'shared/layouts/massActionModalLayout';
import { MassActionItemProps, UseMassActionProps } from 'shared/types';
import { MassActionForm } from 'types/backend';

type NoInputActionForm = undefined;
export type NoInputForm = MassActionForm<NoInputActionForm>;

type NoInputProps<T> = MassActionItemProps<NoInputForm, T, NoInputActionForm>;

export default function NoInput<T>({
    defaultValues,
    onSubmit,
    isLoading,
    tableDataContext,
    rowCount,
    columnConfig,
    allRowsSelected,
}: NoInputProps<T>) {
    return (
        <MassActionModalLayout
            isLoading={isLoading}
            allRowsSelected={allRowsSelected}
            tableDataContext={tableDataContext}
            columnConfig={columnConfig}
            rowCount={rowCount}
            submitHandler={() => onSubmit(defaultValues)}
        ></MassActionModalLayout>
    );
}

export function useNoInputMassAction<T>({
    controllerName,
    affectedDataContext,
    selected,
    allRowsSelected,
    onSuccess,
}: UseMassActionProps<T>) {
    const { filtersApplied } = useContext(affectedDataContext);

    const noInputMapper = (form: NoInputForm) => ({
        ...form,
        filters: filtersApplied,
        selected,
        allRowsSelected,
    });

    return useSubmitNew({
        name: `${controllerName}/massaction/noinput`,
        mapper: noInputMapper,
        context: affectedDataContext,
        onSuccess: onSuccess,
    });
}
